module.exports = __webpack_public_path__ + "catalog/items/bathroom/Toilet_with_cistern/Toiletwithcistern.svg";